import * as i0 from '@angular/core';
import { Directive, Input, HostListener, NgModule } from '@angular/core';
let IMaskDirective = /*#__PURE__*/(() => {
  class IMaskDirective {
    elementRef;
    allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'Home', 'End', 'ArrowLeft', 'ArrowRight', 'Clear', 'Copy', 'Paste', '-'];
    inputElement;
    iMask = null;
    constructor(elementRef) {
      this.elementRef = elementRef;
      this.inputElement = this.elementRef.nativeElement;
    }
    onKeyDown(e) {
      if (!this.iMask) {
        return;
      }
      if (this.allowedKeys.indexOf(e.key) > -1 ||
      // Allow: navigation keys: backspace, delete, arrows etc.
      e.key === 'a' && e.ctrlKey === true ||
      // Allow: Ctrl+A
      e.key === 'c' && e.ctrlKey === true ||
      // Allow: Ctrl+C
      e.key === 'v' && e.ctrlKey === true ||
      // Allow: Ctrl+V
      e.key === 'x' && e.ctrlKey === true ||
      // Allow: Ctrl+X
      e.key === 'a' && e.metaKey === true ||
      // Allow: Cmd+A (Mac)
      e.key === 'c' && e.metaKey === true ||
      // Allow: Cmd+C (Mac)
      e.key === 'v' && e.metaKey === true ||
      // Allow: Cmd+V (Mac)
      e.key === 'x' && e.metaKey === true) {
        // Allow: Cmd+X (Mac)
        // let it happen, don't do anything
        return;
      }
      if (this.iMask === 'number') {
        if (e.key === ' ') {
          e.preventDefault();
        }
        if (isNaN(+e.key)) {
          e.preventDefault();
        }
        return;
      } else {
        if (e.key === ' ') {
          return;
        }
        if (!isNaN(+e.key)) {
          e.preventDefault();
        }
        let value = this.elementRef.nativeElement.value.replace(/\d+/g, ''); // get a non digit-only string
        if (this.iMask === 'uppercase') {
          value = value.toUpperCase();
        }
        this.elementRef.nativeElement.value = value;
        return;
      }
    }
    onInput() {
      let value = this.elementRef.nativeElement.value;
      if (this.iMask === 'number') {
        value = value.replace(/\D/g, ''); // get a digit-only string
      } else if (this.iMask === 'text' || this.iMask === 'uppercase') {
        value = value.replace(/\d+/g, ''); // get a non digit-only string
        if (this.iMask === 'uppercase') {
          value = value.toUpperCase();
        }
      }
      this.elementRef.nativeElement.value = value;
    }
    static ɵfac = function IMaskDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IMaskDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: IMaskDirective,
      selectors: [["input", "iMask", ""]],
      hostBindings: function IMaskDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("keydown", function IMaskDirective_keydown_HostBindingHandler($event) {
            return ctx.onKeyDown($event);
          })("input", function IMaskDirective_input_HostBindingHandler($event) {
            return ctx.onInput($event);
          });
        }
      },
      inputs: {
        iMask: "iMask"
      }
    });
  }
  return IMaskDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IMaskModule = /*#__PURE__*/(() => {
  class IMaskModule {
    static ɵfac = function IMaskModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IMaskModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: IMaskModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return IMaskModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of shared
 */

/**
 * Generated bundle index. Do not edit.
 */

export { IMaskDirective, IMaskModule };
